import _cloneDeep from 'lodash/cloneDeep'
import _filter from 'lodash/filter'

class DeviceController {
  mountType;
  device;
  freeSpace;
  reservedSpace;
  isInstalled;
  constructor ($scope, $rootScope, SDFilterService, $log) {
    'ngInject'

    this.$rootScope = $rootScope
    this.$log = $log
    this.sdFilterService = SDFilterService
    this.sdfilter = this
    this.isProcessing = false
    $scope.$on('device-content:close', (event, data) => {
      this.showContents = false
    })
  }

  $onInit () {
    this.deviceBeforeSync = _cloneDeep(this.device)
  }

  get deviceNameLabel () {
    const { device } = this
    let deviceNameLabel
    switch (device.mountType) {
      case 'Internal':
        deviceNameLabel = 'my-updates.device.mountType.internal'
        break
      case 'SD Card':
        deviceNameLabel = 'my-updates.device.mountType.sd_card_mm12'
        break
      case 'External memory':
        deviceNameLabel = 'my-updates.device.mountType.sd_card_radnav'
        break
      default:
        deviceNameLabel = 'my-updates.device.mountType.internal'
        break
    }
    return deviceNameLabel
  }

  get space () {
    const { device } = this
    let space = (device.totalSpace - device.freeSpace + device.reservedSpace) / 1048576 // 1048576 octets is 1 Mo
    return Math.round(space) + 'Mo'
  }

  get totalSpace () {
    const { device } = this
    let totalSpace = device.totalSpace / 1048576
    return Math.round(totalSpace) + 'Mo'
  }

  get progressbarSpace () {
    const { device } = this
    return (device.totalSpace - device.freeSpace + device.reservedSpace) / device.totalSpace * 100
  }

  get mountId () {
    const { device } = this
    let id = ''
    if (device.mountType === 'SD Card') {
      id = device.mountId
    }
    return id
  }

  get progressbarStyle () {
    let type = 'success'
    if (this.progressbarSpace > 50) type = 'danger'
    return type
  }

  get availableContents () {
    const { device } = this
    return device.availableContents.availableContent
  }

  get currentVehicle () {
    const { vehicle } = this
    return vehicle
  }

  toggleContents () {
    let show = this.showContents
    this.$rootScope.$broadcast('device-content:close')
    this.showContents = !show
  }

  synchronize () {
    // this.$log.debug('Synchronize')
    this.isProcessing = true
    this.info = null
    const { device, deviceBeforeSync } = this
    let productsToInstall = []
    let productsToDelete = []
    // this.$log.debug('Device', device)
    // this.$log.debug('Device before modifications', deviceBeforeSync)
    device.availableContents.availableContent.forEach((availableContent) => {
      const availableContentBeforeSync = _filter(deviceBeforeSync.availableContents.availableContent, {'ref': availableContent.ref})[0]
      // this.$log.debug('availableContentBeforeSync', availableContentBeforeSync)
      if (availableContent.isInstalled !== availableContentBeforeSync.isInstalled && !availableContent.isLocked) {
        // this.$log.debug('availableContent.isInstalled', availableContent.isInstalled)
        // this.$log.debug('availableContentBeforeSync.isInstalled', availableContentBeforeSync.isInstalled)
        if (availableContent.isInstalled) {
          productsToInstall.push(availableContent.ref)
        } else {
          productsToDelete.push(availableContent.ref)
        }
      }
    })
    // this.$log.debug('Products to install', productsToInstall)
    // this.$log.debug('Products to delete', productsToDelete)
    if (productsToInstall.length === 0 && productsToDelete.length === 0) {
      this.$log.error('Nothing to synchronize')
      this.error = {
        message: 'my-updates.device.synchronization_no_change'
      }
    } else {
      const syncProducts = {
        productsToInstall,
        productsToDelete
      }
      this.$log.debug('Products to synchronize', syncProducts)
      return this.onSynchronize({device, syncProducts})
    }
  }

  isDisplayShowBtn () {
    if (this.sdfilter === 'disabled') {
      return true
    }
    return false
  }

  isDisplayHideBtn () {
    if (this.sdfilter === 'display') {
      return true
    }
    return false
  }

  isDisabledBox () {
    if (this.sdfilter === 'disabled') {
      return true
    }
    return false
  }

  showDevice () {
    this.isProcessing = true
    const { device } = this
    this.onShowHideBeforeApiCall({mountId: device.mountId, show: true})
    this.sdFilterService.changeSDDeviceFilterStatus(device.mountId, 'show').then((res) => {
      this.isProcessing = false
      return this.onFilterAction()
    })
  }

  hideDevice () {
    this.isProcessing = true
    const { device } = this
    this.onShowHideBeforeApiCall({mountId: device.mountId, show: false})
    this.sdFilterService.changeSDDeviceFilterStatus(device.mountId, 'hide').then((res) => {
      this.isProcessing = false
      return this.onFilterAction()
    })
  }
}

export default DeviceController



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/device/device.controller.js